/**
 * Width of a creation step's content column, from the design's own step container. Named
 * once because the steps have to agree: they were built from the previous step's 650, which
 * read as narrow next to the design and had to be corrected in every step at once.
 *
 * Written as a full class string so Tailwind still finds it in the source.
 */
export const STEP_COLUMN_WIDTH = 'max-w-[700px]';

/**
 * The same width as a number, for consumers that take one rather than a class - the wizard's
 * `ActionFooter`, which has to line up with the column above it. Tailwind cannot read an
 * interpolated class name, so the value is spelled twice rather than derived; change both.
 */
export const STEP_COLUMN_MAX_WIDTH = 700;
